/**
 *  @object
 *  @function ProductZoomFilmstrip
 *  @description Full-screen horizontal "filmstrip" zoom view for the PDP gallery, with infinite looping.
 */
(function () {
	if (window.ProductZoomFilmstrip) return;

	const root = document.getElementById('product-zoom-filmstrip-root');
	if (!root) return;

	const track = root.querySelector('#ProductZoomFilmstripTrack');
	const closeBtn = root.querySelector('#ProductZoomFilmstripClose');
	const prevBtn = root.querySelector('#ProductZoomFilmstripPrev');
	const nextBtn = root.querySelector('#ProductZoomFilmstripNext');

	let slides = [];
	let realCount = 0;
	let currentIndex = 1;
	let scrollTimer = null;
	let suppressTimer = null;
	let settleTimer = null;
	let suppressScrollSync = false;

	function makeSlide(item) {
		const slide = document.createElement('div');
		slide.className = 'product-zoom-filmstrip__slide';
		const img = document.createElement('img');
		img.src = item.src;
		img.alt = item.alt || '';
		img.loading = 'eager';
		slide.appendChild(img);
		return slide;
	}

	function build(items) {
		track.innerHTML = '';
		realCount = items.length;

		const domItems = realCount > 1
			? [items[realCount - 1], ...items, items[0]]
			: items;

		slides = domItems.map((item) => {
			const slide = makeSlide(item);
			track.appendChild(slide);
			return slide;
		});
	}

	function scrollToIndex(index, behavior) {
		suppressScrollSync = true;
		slides[index].scrollIntoView({ inline: 'center', block: 'nearest', behavior });
		clearTimeout(suppressTimer);
		suppressTimer = setTimeout(() => { suppressScrollSync = false; }, behavior === 'smooth' ? 450 : 50);
	}

	function correctLoopBoundary() {
		if (realCount <= 1) return;
		if (currentIndex === 0) {
			currentIndex = realCount;
			scrollToIndex(currentIndex, 'auto');
		} else if (currentIndex === slides.length - 1) {
			currentIndex = 1;
			scrollToIndex(currentIndex, 'auto');
		}
	}

	function goTo(index) {
		if (!slides.length) return;
		currentIndex = index;
		scrollToIndex(currentIndex, 'smooth');
		clearTimeout(settleTimer);
		settleTimer = setTimeout(correctLoopBoundary, 450);
	}

	function nearestIndexFromScroll() {
		if (!slides.length) return currentIndex;
		const trackRect = track.getBoundingClientRect();
		const center = trackRect.left + trackRect.width / 2;
		let closest = 0;
		let closestDistance = Infinity;
		slides.forEach((slide, i) => {
			const rect = slide.getBoundingClientRect();
			const slideCenter = rect.left + rect.width / 2;
			const distance = Math.abs(slideCenter - center);
			if (distance < closestDistance) {
				closestDistance = distance;
				closest = i;
			}
		});
		return closest;
	}

	function onTrackScroll() {
		if (suppressScrollSync) return;
		clearTimeout(scrollTimer);
		scrollTimer = setTimeout(() => {
			currentIndex = nearestIndexFromScroll();
			correctLoopBoundary();
		}, 120);
	}

	function onTrackWheel(event) {
		if (!event.deltaY) return;
		event.preventDefault();
		track.scrollBy({ left: event.deltaY, behavior: 'smooth' });
	}

	function openFilmstrip(items, startIndex) {
		build(items);
		root.classList.add('active');
		root.removeAttribute('inert');
		document.body.classList.add('product-zoom-filmstrip-open');
		track.addEventListener('scroll', onTrackScroll, { passive: true });
		track.addEventListener('wheel', onTrackWheel, { passive: false });
		const initialIndex = realCount > 1 ? (startIndex || 0) + 1 : 0;
		requestAnimationFrame(() => {
			currentIndex = initialIndex;
			scrollToIndex(currentIndex, 'auto');
		});
		closeBtn.focus();
	}

	function closeFilmstrip() {
		root.classList.remove('active');
		root.setAttribute('inert', '');
		document.body.classList.remove('product-zoom-filmstrip-open');
		track.removeEventListener('scroll', onTrackScroll);
	}

	closeBtn.addEventListener('click', closeFilmstrip);
	prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
	nextBtn.addEventListener('click', () => goTo(currentIndex + 1));

	document.addEventListener('keydown', (e) => {
		if (!root.classList.contains('active')) return;
		if (e.key === 'Escape') closeFilmstrip();
		if (e.key === 'ArrowLeft') goTo(currentIndex - 1);
		if (e.key === 'ArrowRight') goTo(currentIndex + 1);
	});

	window.ProductZoomFilmstrip = { open: openFilmstrip, close: closeFilmstrip };
})();
